"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var __1 = tslib_1.__importDefault(require("../.."));
var DateUtil_1 = require("../../util/DateUtil");
var valToArray_1 = require("../../util/valToArray");
var TimeRangeAccessor_1 = tslib_1.__importDefault(require("./TimeRangeAccessor"));
var W3CDDateRangeAccessor_1 = tslib_1.__importDefault(require("./W3CDDateRangeAccessor"));
var TypedObjectAccessor = (function () {
    function TypedObjectAccessor(target) {
        if (target) {
            this._target = target;
        }
        else {
            this._target = {};
        }
        this._objAccessorLut = {};
    }
    Object.defineProperty(TypedObjectAccessor.prototype, "target", {
        get: function () {
            return this._target;
        },
        set: function (val) {
            this._target = val;
            this._objAccessorLut = {};
        },
        enumerable: false,
        configurable: true
    });
    TypedObjectAccessor.prototype.has = function (key) {
        return key in this._target;
    };
    TypedObjectAccessor.prototype.keys = function () {
        return Object.keys(this._target);
    };
    TypedObjectAccessor.prototype.raw = function (key, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = null; }
        if (!this.has(key)) {
            return valueIfNotExisting;
        }
        return this._target[key];
    };
    TypedObjectAccessor.prototype.obj = function (key) {
        var val = this.raw(key, {});
        if (!!val && typeof (val) === 'object') {
            return val;
        }
        else {
            return {};
        }
    };
    TypedObjectAccessor.prototype.jsonObj = function (key) {
        var jsonObj;
        try {
            jsonObj = JSON.parse(this.str(key));
        }
        catch (err) {
            jsonObj = {};
        }
        return jsonObj;
    };
    TypedObjectAccessor.prototype.objacc = function (key, createNewAccessor) {
        if (createNewAccessor === void 0) { createNewAccessor = false; }
        if (!(key in this._objAccessorLut) || createNewAccessor) {
            var val = this.raw(key);
            switch (typeof (val)) {
                case 'string':
                    val = this.jsonObj(key);
                    break;
                case 'object':
                    break;
                default:
                    val = {};
                    break;
            }
            this._objAccessorLut[key] = new TypedObjectAccessor(val);
        }
        return this._objAccessorLut[key];
    };
    TypedObjectAccessor.prototype.bool = function (key, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = false; }
        var val = this.raw(key, valueIfNotExisting);
        if (typeof (val) === 'string') {
            return !(val === 'false');
        }
        return !!this.raw(key, valueIfNotExisting);
    };
    TypedObjectAccessor.prototype.str = function (key, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = ''; }
        var val = this.raw(key, valueIfNotExisting);
        var type = typeof (val);
        switch (type) {
            case 'string':
                return val;
            case 'number':
                return String(val);
            default:
                return valueIfNotExisting;
        }
    };
    TypedObjectAccessor.prototype.isstr = function (key, value, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = ''; }
        return this.str(key, valueIfNotExisting) === value;
    };
    TypedObjectAccessor.prototype.float = function (key, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = 0; }
        var val = this.raw(key, valueIfNotExisting);
        var type = typeof (val);
        switch (type) {
            case 'number':
                return val;
            case 'string':
                return Number(val);
            case 'boolean':
                return val ? 1 : 0;
            default:
                return valueIfNotExisting;
        }
    };
    TypedObjectAccessor.prototype.isfloat = function (key, value, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = 0; }
        return this.float(key, valueIfNotExisting) === value;
    };
    TypedObjectAccessor.prototype.integer = function (key, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = 0; }
        return Math.floor(this.float(key, valueIfNotExisting));
    };
    TypedObjectAccessor.prototype.isinteger = function (key, value, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = 0; }
        return this.integer(key, valueIfNotExisting) === value;
    };
    TypedObjectAccessor.prototype.color = function (key, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = 0x00; }
        var rawColor = this.raw(key);
        if (typeof (rawColor) === 'number') {
            return rawColor;
        }
        var colorStr = this.str(key);
        if (!colorStr) {
            return valueIfNotExisting;
        }
        if (colorStr.indexOf('#') === 0) {
            return parseInt(colorStr.slice(1), 16);
        }
        else if (colorStr.indexOf('0x') === 0) {
            return parseInt(colorStr.slice(2), 16);
        }
        return parseInt(colorStr, 16);
    };
    TypedObjectAccessor.prototype.w3cddate = function (key) {
        try {
            return DateUtil_1.parseW3CDTF(this.str(key));
        }
        catch (err) {
            return new Date();
        }
    };
    TypedObjectAccessor.prototype.w3cddaterange = function (key, startPropertyKey, endPropertyKey) {
        if (startPropertyKey === void 0) { startPropertyKey = 'Timestamp'; }
        if (endPropertyKey === void 0) { endPropertyKey = 'EndTimestamp'; }
        var accessor;
        var vals = this.obj(key);
        try {
            accessor = new W3CDDateRangeAccessor_1.default(DateUtil_1.parseW3CDTF(vals[startPropertyKey]));
            if (vals.hasOwnProperty(endPropertyKey)) {
                accessor.end = DateUtil_1.parseW3CDTF(vals[endPropertyKey]);
            }
        }
        catch (err) {
            accessor = new W3CDDateRangeAccessor_1.default(new Date());
        }
        return accessor;
    };
    TypedObjectAccessor.prototype.isInW3cddaterange = function (key, date, startPropertyKey, endPropertyKey) {
        if (startPropertyKey === void 0) { startPropertyKey = 'Timestamp'; }
        if (endPropertyKey === void 0) { endPropertyKey = 'EndTimestamp'; }
        return this.w3cddaterange(key, startPropertyKey, endPropertyKey).isInRange(date);
    };
    TypedObjectAccessor.prototype.timerange = function (key, startPropertyKey, endPropertyKey) {
        if (startPropertyKey === void 0) { startPropertyKey = 'Time'; }
        if (endPropertyKey === void 0) { endPropertyKey = 'EndTime'; }
        var accessor;
        var vals = this.obj(key);
        var ar = valToArray_1.valToArray(vals[startPropertyKey]);
        if (ar.length === 2) {
            accessor = new TimeRangeAccessor_1.default(ar[0], ar[1]);
            ar = valToArray_1.valToArray(vals[endPropertyKey]);
            if (ar.length === 2) {
                accessor.endHour = ar[0];
                accessor.endMinute = ar[1];
            }
        }
        else {
            accessor = new TimeRangeAccessor_1.default(0, 0);
        }
        return accessor;
    };
    TypedObjectAccessor.prototype.isInTimerange = function (key, date, startPropertyKey, endPropertyKey) {
        if (startPropertyKey === void 0) { startPropertyKey = 'Time'; }
        if (endPropertyKey === void 0) { endPropertyKey = 'EndTime'; }
        return this.timerange(key, startPropertyKey, endPropertyKey).isInRange(date);
    };
    TypedObjectAccessor.prototype.arr = function (key, removeDuplicates) {
        if (removeDuplicates === void 0) { removeDuplicates = false; }
        var ar = valToArray_1.valToArray(this.raw(key, null));
        if (removeDuplicates) {
            var uniqueAr_1 = new Array();
            ar.forEach(function (arElement) {
                if (uniqueAr_1.indexOf(arElement) === -1) {
                    uniqueAr_1.push(arElement);
                }
            });
            return uniqueAr_1;
        }
        return ar;
    };
    TypedObjectAccessor.prototype.strlist = function (key, removeDuplicates) {
        if (removeDuplicates === void 0) { removeDuplicates = false; }
        var list;
        try {
            list = this.arr(key, removeDuplicates);
            var i = list.length;
            while (--i >= 0) {
                switch (typeof (list[i])) {
                    case 'number':
                        list[i] = String(list[i]);
                        break;
                    case 'string':
                        break;
                    default:
                        list.splice(i, 1);
                        break;
                }
            }
        }
        catch (err) {
            list = new Array();
        }
        return list;
    };
    TypedObjectAccessor.prototype.isinStrlist = function (key, value) {
        return this.strlist(key).indexOf(value) !== -1;
    };
    TypedObjectAccessor.prototype.intlist = function (key, size, fillElementsWith) {
        if (size === void 0) { size = -1; }
        if (fillElementsWith === void 0) { fillElementsWith = 0; }
        var list = new Array();
        var ar = this.arr(key);
        for (var _i = 0, ar_1 = ar; _i < ar_1.length; _i++) {
            var arElement = ar_1[_i];
            switch (typeof (arElement)) {
                case 'string':
                    list.push(Math.floor(Number(arElement)));
                    break;
                case 'number':
                    list.push(Math.floor(arElement));
                    break;
                default:
                    break;
            }
        }
        if (size > 0) {
            if (list.length > size) {
                list = list.splice(0, size);
            }
            else {
                while (list.length < size) {
                    list.push(fillElementsWith);
                }
            }
        }
        return list;
    };
    TypedObjectAccessor.prototype.objlist = function (key) {
        var list = new Array();
        this.arr(key).forEach(function (val) {
            if (typeof (val) === 'object') {
                list.push(val);
            }
        });
        return list;
    };
    TypedObjectAccessor.prototype.objacclist = function (key) {
        var list = new Array();
        this.objlist(key).forEach(function (obj) {
            list.push(new TypedObjectAccessor(obj));
        });
        return list;
    };
    TypedObjectAccessor.prototype.ref = function (contentFieldId) {
        return __1.default.instance.getContentModel(this.str(contentFieldId));
    };
    TypedObjectAccessor.prototype.reflist = function (contentFieldId, createIfNecessary, removeDuplicates) {
        if (createIfNecessary === void 0) { createIfNecessary = false; }
        if (removeDuplicates === void 0) { removeDuplicates = false; }
        var uids = this.strlist(contentFieldId, removeDuplicates);
        var refs = new Array();
        for (var _i = 0, uids_1 = uids; _i < uids_1.length; _i++) {
            var uid = uids_1[_i];
            if (!createIfNecessary && !__1.default.instance.modelExists(uid)) {
                continue;
            }
            refs.push(__1.default.instance.getContentModel(uid));
        }
        return refs;
    };
    TypedObjectAccessor.prototype.reffromreflist = function (contentFieldId, uid, createIfNecessary) {
        if (createIfNecessary === void 0) { createIfNecessary = false; }
        if (!uid) {
            return null;
        }
        var uids = this.strlist(contentFieldId);
        if (uids.indexOf(uid) === -1) {
            return null;
        }
        if (!createIfNecessary && !__1.default.instance.modelExists(uid)) {
            return null;
        }
        return __1.default.instance.getContentModel(uid);
    };
    TypedObjectAccessor.prototype.addValue = function (key, value) {
        this._target[key] = value;
    };
    TypedObjectAccessor.prototype.removeValue = function (key) {
        delete this._target[key];
    };
    return TypedObjectAccessor;
}());
exports.default = TypedObjectAccessor;
